import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axiosPrivate from 'config/axiosPrivate';

import { ORDERSTATUS } from 'utils/Constants';
import WriterClientProjectTable from 'components/shared/WriterClientProjectTable';
import usePageTracking from 'utils/hooks/usePageTracking';

const WRITER_CLIENT_PROJECTS_VALIDATED_PAGE = '/WriterClient/ProjectsValides';

export default function ValidatedProjects() {
  usePageTracking(WRITER_CLIENT_PROJECTS_VALIDATED_PAGE);

  const { t } = useTranslation();

  const [validatedOrders, setValidatedOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));

    const fetchProjects = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        const response = await axiosPrivate.get('/project/by-status');
        if (response.status === 200) {
          const validated = response.data?.validatedProjects ?? [];
          setValidatedOrders(validated);
        }
      } catch (error) {
        setIsError(true);
        console.error('Error fetching validated projects:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <WriterClientProjectTable
      title={t('Projets validés')}
      orderStatus={ORDERSTATUS.VALID}
      orders={validatedOrders}
      isLoading={isLoading}
      isError={isError}
      onRowClickRedirectPath="/WriterClient/DetailsProject"
    />
  );
}


